import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import { Provider } from 'react-redux';
import store from './store/index';
import './index.css';
import './dark-theme.css';
import './i18n';
import App from './App';
import Pracenje from './components/Pracenje/Pracenje';
import reportWebVitals from './reportWebVitals';
import { PrimeReactProvider } from 'primereact/api';
import { applyTheme, getStoredTheme } from './theme';

// Primeni temu ODMAH (pre renderovanja) da nema treptaja svetle teme na dark korisniku
applyTheme(getStoredTheme());

/* Javna strana praćenja naloga (/pracenje/<token>) se renderuje UMESTO cele
   aplikacije. Nije u njenom Route stablu namerno: gost nije prijavljen, pa bi
   App pokrenuo prijavu, socket, sesijske provere i alarme — sve ono što traži
   korisnika kog ovde nema. */
const javnoPracenje = window.location.pathname.split('/').filter(Boolean)[0] === 'pracenje';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    {/* Slojevi PrimeReact-a.

        overlay je namerno 9000, a ne 1000: nasi modali (.confirmation-modal)
        su u CSS-u prikovani na z-index 10000 da bi bili iznad poziva u catu
        (9999). PrimeReact za to ne zna — svoj dijalog racuna na ~1101, pa bi
        panelu dropdowna dao ~2102 i panel bi zavrsio ISPOD modala: lista se
        otvori, ali se ne vidi.

        Sa 9000, panel otvoren u modalu dobija 1101 + 9000 + 1 = 10102, dakle
        iznad modala. Panel otvoren van modala dobija 9001 — iznad mape i
        Leaflet kontrola, a i dalje ispod poziva u catu. */}
    <PrimeReactProvider value={{ zIndex: { modal: 1100, overlay: 9000, menu: 1050, tooltip: 1200 } }}>
      <Provider store={store}>
        {javnoPracenje ? <Pracenje /> : <App />}
      </Provider>
    </PrimeReactProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
